var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0L20.4102 2.63672L7.91016 9.86328L3.32031 12.5V37.5L7.91016 40.1367L20.5273 47.3633L25.1172 50L29.707 47.3633L42.0898 40.1367L46.6797 37.5V12.5L42.0898 9.86328L29.5898 2.63672L25 0ZM12.5 32.2266V17.7734L25 10.5469L37.5 17.7734V32.2266L25 39.4531L12.5 32.2266Z",
    fill: "#2A5ADA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg32);
export default __webpack_public_path__ + "static/media/32.c200c2dbbb50994795163ed4b69c2662.svg";
export { ForwardRef as ReactComponent };